
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components-v2/elements/button';
import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';

const JoinButton = ({
   settings,
   globalSettings,
}) => {
   const { getSitePrimaryColor } = useSiteGlobalSettingsHelper(globalSettings);
   if(!settings.enabled) return null;
   return (
      <div className='h-11 inline-flex'>
         <Button
            text={ settings?.text }
            buttonType='submit'
            type='primary'
            size='small'
            className='w-full'
            buttonClassName='w-full'
            primaryColor={ getSitePrimaryColor() }
            onClick={ () => {} }
         />
      </div>
   )

}
JoinButton.propTypes = {
   settings: PropTypes.object,
   globalSettings: PropTypes.object,
};

export default JoinButton;


